module.exports = __webpack_public_path__ + "img/penalties.2cfa2f0.png";